import { mutate } from 'swr';
import axios from 'axios';
import { Notistack } from '../../../../../../../../shared/components/Notistack/Notistack';
import { TTierCondition } from '../../../../interfaces';

export const requestCreateCondition = (lenderId: string, tierId = '', condition: TTierCondition) => {
  const path = tierId && `/lender-service/lenders/${lenderId}/tierCondition/${tierId}`;
  return mutate(`/lender-service/lenders/${lenderId}`, async() => {
    try {
      await axios.put(path, condition);
      Notistack.successMessage('Condition - Created Successfully');
    } catch {
      Notistack.generalError();
    }
  });
};

export const requestUpdateCondition = (lenderId: string, condition: TTierCondition) => {
  const path = `/lender-service/lenders/${lenderId}/tierCondition`;
  return mutate(`/lender-service/lenders/${lenderId}`, async() => {
    try {
      await axios.patch(path, condition);
      Notistack.successMessage('Condition - Updated Successfully');
    } catch {
      Notistack.generalError();
    }
  });
};

export const requestCopyCondition = (lenderId: string, conditionId = '') => {
  const path = conditionId && `/lender-service/lenders/${lenderId}/tierCondition-copy/${conditionId}`;
  return mutate(`/lender-service/lenders/${lenderId}`, async() => {
    try {
      await axios.post(path);
      Notistack.successMessage('Condition - Copied Successfully');
    } catch {
      Notistack.generalError();
    }
  });
};

export const requestDeleteCondition = (lenderId: string, conditionId = '') => {
  const path = conditionId && `/lender-service/lenders/${lenderId}/tierCondition/${conditionId}`;
  return mutate(`/lender-service/lenders/${lenderId}`, async() => {
    try {
      await axios.delete(path);
      Notistack.successMessage('Condition - Deleted Successfully');
    } catch {
      Notistack.generalError();
    }
  });
};
